import { query } from "$app/server";
import { z } from "zod";
import { BetaAnalyticsDataClient } from "@google-analytics/data";
import {
  PRIVATE_GOOGLE_ANALYTICS_CLIENT_EMAIL,
  PRIVATE_GOOGLE_ANALYTICS_PRIVAT_KEY,
  PRIVATE_GOOGLE_ANALYTICS_PROPERTY_ID,
} from "$app/env/private";

let analyticsDataClient: BetaAnalyticsDataClient;

export const getAnalytics = query(z.object({}), async () => {
  try {
    if (!analyticsDataClient) {
      analyticsDataClient = new BetaAnalyticsDataClient({
        credentials: {
          client_email: PRIVATE_GOOGLE_ANALYTICS_CLIENT_EMAIL,
          private_key: PRIVATE_GOOGLE_ANALYTICS_PRIVAT_KEY.replace(
            /\\n/g,
            "\n",
          ),
        },
      });
    }

    // Fetch Active Users (Realtime - last 30 mins)
    const [realtimeResponse] = await analyticsDataClient.runRealtimeReport({
      property: `properties/${PRIVATE_GOOGLE_ANALYTICS_PROPERTY_ID}`,
      metrics: [{ name: "activeUsers" }],
    });

    // Fetch Total Users (Historical - from 2020 to today)
    const [reportResponse] = await analyticsDataClient.runReport({
      property: `properties/${PRIVATE_GOOGLE_ANALYTICS_PROPERTY_ID}`,
      dateRanges: [{ startDate: "2020-01-01", endDate: "today" }],
      metrics: [{ name: "totalUsers" }],
    });

    const activeUsers =
      realtimeResponse.rows?.[0]?.metricValues?.[0]?.value || "0";
    const totalUsers =
      reportResponse.rows?.[0]?.metricValues?.[0]?.value || "0";

    return {
      active: parseInt(activeUsers, 10),
      total: parseInt(totalUsers, 10),
    };
  } catch (error) {
    console.error("Error fetching Google Analytics data:", error);
    return { active: 0, total: 0 };
  }
});
